import { render, staticRenderFns } from "./WardrobeDoorsMaterial.vue?vue&type=template&id=7e416923&"
import script from "./WardrobeDoorsMaterial.vue?vue&type=script&lang=js&"
export * from "./WardrobeDoorsMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports